<template>
	<div class="dorm-kpi">
		<div class="dorm-kpi-board">
			<div class="dorm-kpi-panel hero">
				<div class="dorm-kpi-head">
					<strong>总览</strong>
					<span>人数 / 请假</span>
				</div>
				<div class="dorm-kpi-row cols-2">
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value cyan">{{ pick('stuCount') }}</div>
						<div class="dorm-kpi-label">总人数</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value leave">{{ pick('stuLeave') }}</div>
						<div class="dorm-kpi-label">请假</div>
					</div>
				</div>
			</div>
			<div class="dorm-kpi-panel">
				<div class="dorm-kpi-head">
					<strong>实时位置</strong>
					<span>当天最后门禁</span>
				</div>
				<div class="dorm-kpi-row cols-3">
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value ok">{{ pickPresenceIn() }}</div>
						<div class="dorm-kpi-label">在寝</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value warn">{{ pickPresenceOut() }}</div>
						<div class="dorm-kpi-label">出寝</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value wait">{{ pick('unknownPresenceCount') }}</div>
						<div class="dorm-kpi-label">无通行</div>
					</div>
				</div>
			</div>
			<div class="dorm-kpi-panel">
				<div class="dorm-kpi-head">
					<strong>离寝考勤</strong>
				</div>
				<div class="dorm-kpi-row cols-3">
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value ok">{{ pick('morningExitedCount') }}</div>
						<div class="dorm-kpi-label">离寝合计</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value bad">{{ pick('morningNotExitedCount') }}</div>
						<div class="dorm-kpi-label">未离寝</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value warn">{{ pick('morningLateExitCount') }}</div>
						<div class="dorm-kpi-label">晚离</div>
					</div>
				</div>
			</div>
			<div class="dorm-kpi-panel">
				<div class="dorm-kpi-head">
					<strong>归寝考勤</strong>
				</div>
				<div class="dorm-kpi-row cols-3">
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value ok">{{ pick('eveningReturnedCount') }}</div>
						<div class="dorm-kpi-label">归寝合计</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value bad">{{ pick('eveningNotReturnedCount') }}</div>
						<div class="dorm-kpi-label">未归寝</div>
					</div>
					<div class="dorm-kpi-card">
						<div class="dorm-kpi-value warn">{{ pick('eveningLateReturnCount') }}</div>
						<div class="dorm-kpi-label">晚归</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DormKpiBoard',
	props: {
		data: { type: Object, default: () => ({}) },
	},
	methods: {
		pick(key) {
			const value = this.data && this.data[key]
			if (value == null || value === '') return '0'
			return String(value)
		},
		pickPresenceIn() {
			const d = this.data || {}
			if (d.inDormCount != null && d.inDormCount !== '') return String(d.inDormCount)
			return this.pick('stuBack')
		},
		pickPresenceOut() {
			const d = this.data || {}
			if (d.outDormCount != null && d.outDormCount !== '') return String(d.outDormCount)
			return this.pick('stuOut')
		},
	},
}
</script>

<style scoped>
.dorm-kpi {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	border: 1px solid rgba(45, 118, 252, 0.45);
	background: rgba(8, 18, 48, 0.55);
}
.dorm-kpi-board {
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 1.05fr 1.4fr 1.25fr 1.25fr;
	align-items: stretch;
	box-sizing: border-box;
	padding: 0.35vw 0.4vw;
}
.dorm-kpi-panel {
	min-width: 0;
	min-height: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: 0.2vw 0.45vw;
	border-right: 1px solid rgba(148, 163, 184, 0.18);
}
.dorm-kpi-panel:last-child {
	border-right: 0;
}
.dorm-kpi-panel.hero {
	background: linear-gradient(180deg, rgba(14, 116, 144, 0.14), transparent 70%);
}
.dorm-kpi-head {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 0.3vw;
	margin-bottom: 0.08vw;
}
.dorm-kpi-head strong {
	color: #f8fafc;
	font-size: 1.1vw;
	font-weight: 600;
	white-space: nowrap;
}
.dorm-kpi-head span {
	color: #cbd5e1;
	font-size: 0.88vw;
	white-space: nowrap;
}
.dorm-kpi-row {
	flex: 1;
	min-height: 0;
	display: grid;
	align-items: center;
	gap: 0.1vw;
}
.cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.dorm-kpi-card {
	text-align: center;
}
.dorm-kpi-value {
	color: #f8fafc;
	font-size: 2.2vw;
	font-weight: 700;
	line-height: 1;
	font-variant-numeric: tabular-nums;
}
.dorm-kpi-value.cyan { color: #7dd3fc; }
.dorm-kpi-value.ok { color: #4ade80; }
.dorm-kpi-value.warn { color: #fbbf24; }
.dorm-kpi-value.bad { color: #f87171; }
.dorm-kpi-value.wait { color: #fb923c; }
.dorm-kpi-value.leave { color: #c084fc; }
.dorm-kpi-label {
	margin-top: 0.3vw;
	color: #e2e8f0;
	font-size: 1vw;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
